// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cocktails-slider-wrapper .swiper-slide[data-v-ace5efb2]{transform:translateX(70%)}.cocktails-slider-wrapper.is-inview .swiper-slide[data-v-ace5efb2]{transform:translateX(0);transition:all 1s cubic-bezier(0,.08,.06,.99)}", ""]);
// Exports
module.exports = exports;
